import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router'
import './App.css';
import Login from './view/login';
import SignIn from './view/signIn';
import hans from './assets/json/hans.json'
import hant from './assets/json/hant.json'
import en from './assets/json/en.json'
import config from './config'
import axios from 'axios';
function App() {
  const [lang, setLang] = useState(hans)

  useEffect(() => {
    if (window.location.hostname.indexOf('cocorobo.com') > -1) {
      setLang(en)
    } else if (window.location.hostname.indexOf('cocorobo.hk') > -1) {
      setLang(hant)
    } else {
      setLang(hans)
    }
    axios.defaults.withCredentials = true;
    axios.get(`${config.api}api/getcookieuserid`).then(res => {
      if (res.data.length > 0) {
        axios.get(`${config.edu}admin/userinfo/userinfoById/${res.data[0][0].userid}`).then(r => {
          if (r.data.length > 0) {
            postMessageToParent('loginVerify', 'logged', r.data[0][0])
          }
        })
      }
    }).catch(e => {
      console.log(e)
    })
  }, [])
  const postMessageToParent = (id, status, data) => {
    //TODO: replace origin
    let result = {
      id,
      status,
      data
    }
    window.parent.postMessage(result, '*')
  }
  return (
    <BrowserRouter>
      <Routes>
        <Route path="" element={<Login lang={lang} />} />
        <Route path="signIn" element={<SignIn lang={lang} />} />
      </Routes>
    </BrowserRouter>

  );
}

export default App;
